import { CartUpdateEvent } from '@theme/events';

// B2B: component-product availability cache (handle -> fetch promise), shared
// across all quick-add popups on the page so each handle is fetched once.
const b2bComponentCache = {};

function initProductCustom(scope = document) {
  const atcWrappers = scope.matches?.(".atc-icon-wrapper")
    ? [scope]
    : scope.querySelectorAll(".atc-icon-wrapper");

  atcWrappers.forEach((wrapper) => {
    if (wrapper.dataset.productCustomInit === "true") return;

    wrapper.dataset.productCustomInit = "true";

    const openBtn = wrapper.querySelector(".atc-plus-icon");
    const popup = wrapper.querySelector(".variant-popup");
    const closeBtn = wrapper.querySelector(".close-popup-size");
    const popupInner = wrapper.querySelector(".variant-popup-inner");
    const variantButtons = wrapper.querySelectorAll(".custom-size-row");
    const completeLookBtn = wrapper.querySelector(".cmpt-lk");

    if (!openBtn) return;

    // ADD TO CART
    async function addToCart(variantId, qty = 1, isProperties) {
      try {
        setButtonState(openBtn, "loading");

        document.body.classList.remove("atc-opened");
        const itemPayload = {
              id: Number(variantId),
              quantity: qty,
            };
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: [itemPayload],
          }),
        });

        if (!response.ok) {
          throw new Error("Failed to add cart");
        }

        const addedData = await response.json();
        if (typeof triggerKlaviyoAddedToCart === "function") {
          triggerKlaviyoAddedToCart(addedData);
        }

        addedState(openBtn);;
        document.body.classList.remove("cstm-pro-overlay");
        document.dispatchEvent(
          new CartUpdateEvent({
            source: "variant-popup-inner",
          })
        );
      } catch (error) {
        console.error("Cart Error:", error);
      }
    }

    // BUTTON STATES
    function setButtonState(button, state) {
      if (!button) return;

      button.classList.remove(
        "state-default",
        "state-loading",
        "state-success"
      );

      button.classList.add(`state-${state}`);
    }

    function addedState(button) {
      setButtonState(button, "success");

      setTimeout(() => {
        setButtonState(button, "default");
      }, 2000);
    }

    // GET SELECTED OPTIONS
    function getSelectedOptions() {
      const selectedOptions = [];

      wrapper.querySelectorAll(".custom-size-row.active").forEach((btn) => {
        const position = Number(btn.dataset.optionPosition);
        const value = btn.dataset.optionValue;

        if (position && value) {
          selectedOptions[position - 1] = value;
        }
      });

      return selectedOptions;
    }

    // GET MATCHED VARIANT
    function getVariantDataFromJson(jsonString, selectedOptions) {
      if (!jsonString || !selectedOptions.length) return null;

      try {
        const variants = JSON.parse(jsonString);

        const matchedVariant = variants.find((variant) =>
          selectedOptions.every((optionValue, index) => {
            if (!optionValue) return true;

            return (
              String(variant[`option${index + 1}`])
                .trim()
                .toLowerCase() === optionValue.trim().toLowerCase()
            );
          })
        );

        if (!matchedVariant) return null;

        // ELEMENTS
        const changeTitle = completeLookBtn?.querySelector(
          ".add-to-cart-text__content"
        );

        const stockText = completeLookBtn?.nextElementSibling;

        // VALUES
        const inventoryQty = Number(
          matchedVariant.inventory_quantity
        );

        const isPreorder =
          inventoryQty <= 0 &&
          matchedVariant.inventory_policy === "continue";

        const isLowStock =
          matchedVariant.available &&
          inventoryQty > 0 &&
          inventoryQty < 5;

        // BUTTON TEXT
        if (changeTitle) {
          changeTitle.innerText = isPreorder
            ? completeLookBtn.getAttribute("btn-title")
            : "Add to cart";
        }

        // LOW STOCK TEXT
        if (stockText) {
          stockText.innerText = isLowStock
            ? `LOW STOCK - only ${inventoryQty} remaining`
            : "";
        }

        return matchedVariant;
      } catch (error) {
        console.error("Invalid data-json:", error);
        return null;
      }
    }

    // OPEN POPUP
    openBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      document.body.classList.add("atc-opened");

      const variantId = openBtn.dataset.variantId;
      const isProperties = openBtn.dataset.properties ?? false;
      // SIMPLE PRODUCT
      if (variantId) {
        addToCart(variantId, 1, isProperties);
        return;
      }

      // CLOSE OTHER POPUPS
      document.querySelectorAll(".variant-popup").forEach((item) => {
        item.classList.remove("active");
      });

      // OPEN CURRENT POPUP
      popup?.classList.add("active");
      if (openBtn.closest(".mobile-look-products")) {
        document.body.classList.add("cstm-pro-overlay");
      }
    });

    // CLOSE POPUP
    closeBtn?.addEventListener("click", () => {
      popup?.classList.remove("active");
      document.body.classList.remove("cstm-pro-overlay");
      document.body.classList.remove("atc-opened");
    });

    // PREVENT CLOSE
    popupInner?.addEventListener("click", (e) => {
      e.stopPropagation();
    });

    // VARIANT BUTTON CLICK
    variantButtons.forEach((btn) => {
      btn.addEventListener("click", () => {
        const parent = btn.closest(".main-variant");

        // REMOVE ACTIVE
        parent?.querySelectorAll(".custom-size-row").forEach((item) => {
          item.classList.remove("active");
        });

        // ADD ACTIVE
        btn.classList.add("active");

        // GET VARIANT
        const jsonData =
          completeLookBtn?.dataset.json ||
          wrapper.querySelector("[data-json]")?.dataset.json;

        const selectedOptions = getSelectedOptions();

        const matchedVariant = getVariantDataFromJson(
          jsonData,
          selectedOptions
        );
        
        // COMPLETE LOOK PRODUCT
        if (popup?.querySelector(".cmpt-lk")) {
          return;
        }

        // SIMPLE VARIANT PRODUCT
        const variantId = btn.dataset.variantId;

        if (variantId) {
          addToCart(variantId, 1);
        }

        popup?.classList.remove("active");
      });
    });

    // COMPLETE LOOK BUTTON
    completeLookBtn?.addEventListener("click", (e) => {
      e.stopPropagation();

      const selectedOptions = getSelectedOptions();

      const jsonData = completeLookBtn.dataset.json;

      const matchedVariant = getVariantDataFromJson(
        jsonData,
        selectedOptions
      );

      if (matchedVariant?.id) {
        addToCart(matchedVariant.id, 1);

        popup?.classList.remove("active");
      } else {
        console.warn("Matching variant not found");
      }
    });

     // B2B QUICK-ADD (size-run matrix). Bound directly to the button so it fires
    // despite the .variant-popup-inner stopPropagation above.
    const b2bRoot = wrapper.querySelector("[data-b2b-qa]");
    const b2bSubmit = wrapper.querySelector(".b2b-qa__submit");
    if (b2bRoot && b2bSubmit && !b2bSubmit.dataset.b2bBound) {
      b2bSubmit.dataset.b2bBound = "true";

      // Cart-stateful card (Vic 2026-08-28, second pass): the run means
      // TOTALS, mirroring the PDP size run V3. The card prefills from
      // /cart.js when the popup opens, the button reads UPDATE ORDER when
      // the product is already in the order, updates post ABSOLUTE
      // quantities to /cart/update.js (a size cleared to zero is removed,
      // and update.js also adds a size that was not there), first adds post
      // to /cart/add.js, and one authoritative cart re-read after every
      // write re-baselines cells, mode and button, so a server-side clamp
      // or a second tab cannot leave the card lying. Metafield-run cards
      // (data-b2b-handle, shared COMPONENT variants) stay additions-only,
      // for the same reason the PDP holds Sets in add mode: absolute totals
      // written from this card would overwrite units the buyer entered
      // elsewhere. A variant spread over several cart lines also drops the
      // card back to add mode, because /cart/update.js only touches the
      // first matching line.
      const b2bTwoWrap = b2bRoot.querySelector("[data-b2b-two-row]");
      const b2bStateful = !b2bRoot.querySelector("[data-b2b-handle]");
      let b2bInOrderTotal = 0;

      const b2bReadTwoMap = () => {
        try {
          const rawMap = b2bTwoWrap ? b2bTwoWrap.querySelector("[data-b2b-two-map]") : null;
          return rawMap ? JSON.parse(rawMap.textContent) : [];
        } catch (err) { return []; }
      };
      const b2bTopOpt = b2bTwoWrap && b2bTwoWrap.getAttribute("data-b2b-top-opt") === "2" ? "o2" : "o1";
      const b2bBotOpt = b2bTopOpt === "o1" ? "o2" : "o1";

      // Live button status, mirroring the PDP size run (Vic 2026-08-31):
      // the resulting total is the whole point, the buyer never has to work
      // out whether the run adds or replaces if the button tells her the
      // number she ends up with. Baselines live on the inputs
      // (data-b2b-in-order), stamped by every cart re-read; a busy flag
      // keeps ADDING.../UPDATING... untouched mid-flight. For TOP/BOT rows
      // the total only reads while the rows balance; unbalanced rows show
      // the plain label and the click explains the mismatch.
      let b2bBusy = false;
      const b2bUnits = (n) => (n === 1 ? "1 UNIT" : n + " UNITS");
      const b2bAllInputs = () => Array.from(b2bRoot.querySelectorAll(
        b2bTwoWrap ? ".b2b-qa__qty[data-b2b-part]" : ".b2b-qa__qty[data-variant-id]"
      ));
      const b2bValueOf = (input) => {
        const n = parseInt(input.value, 10);
        return isNaN(n) || n < 0 ? 0 : n;
      };
      const b2bNextTotal = () => {
        if (!b2bTwoWrap) {
          return b2bAllInputs().reduce((s, input) => s + b2bValueOf(input), 0);
        }
        let top = 0;
        let bot = 0;
        b2bAllInputs().forEach((input) => {
          if (input.getAttribute("data-b2b-part") === "top") top += b2bValueOf(input);
          else bot += b2bValueOf(input);
        });
        return top === bot ? top : null;
      };
      const b2bHasChanges = () => b2bAllInputs().some((input) => {
        const base = parseInt(input.getAttribute("data-b2b-in-order"), 10);
        return b2bValueOf(input) !== (isNaN(base) ? 0 : base);
      });
      const b2bSetLabel = () => {
        if (b2bBusy) return;
        if (b2bInOrderTotal === 0) {
          const adding = b2bNextTotal();
          b2bSubmit.textContent = adding ? "ADD TO ORDER (" + adding + ")" : "ADD TO ORDER";
          b2bSubmit.disabled = adding === 0;
          return;
        }
        if (!b2bHasChanges()) {
          b2bSubmit.textContent = b2bUnits(b2bInOrderTotal) + " IN YOUR ORDER";
          b2bSubmit.disabled = true;
          return;
        }
        const next = b2bNextTotal();
        if (next === 0) {
          b2bSubmit.textContent = "UPDATE ORDER · REMOVE ALL " + b2bUnits(b2bInOrderTotal);
        } else if (next === null) {
          b2bSubmit.textContent = "UPDATE ORDER";
        } else {
          b2bSubmit.textContent = "UPDATE ORDER · " + b2bInOrderTotal + " → " + b2bUnits(next);
        }
        b2bSubmit.disabled = false;
      };
      b2bRoot.querySelectorAll(".b2b-qa__qty").forEach((input) => {
        input.addEventListener("input", b2bSetLabel);
        input.addEventListener("change", b2bSetLabel);
      });

      const b2bSync = () => {
        if (!b2bStateful) return Promise.resolve();
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (!cart || !cart.items) return;
            const qtyByVid = {};
            const linesByVid = {};
            cart.items.forEach((line) => {
              const vid = String(line.variant_id);
              qtyByVid[vid] = (qtyByVid[vid] || 0) + line.quantity;
              linesByVid[vid] = (linesByVid[vid] || 0) + 1;
            });
            let total = 0;
            let split = false;
            if (b2bTwoWrap) {
              const topCounts = {};
              const botCounts = {};
              b2bReadTwoMap().forEach((v) => {
                const vid = String(v.id);
                if ((linesByVid[vid] || 0) > 1) split = true;
                const q = qtyByVid[vid] || 0;
                if (q > 0) {
                  topCounts[String(v[b2bTopOpt])] = (topCounts[String(v[b2bTopOpt])] || 0) + q;
                  botCounts[String(v[b2bBotOpt])] = (botCounts[String(v[b2bBotOpt])] || 0) + q;
                  total += q;
                }
              });
              b2bTwoWrap.querySelectorAll(".b2b-qa__qty[data-b2b-part]").forEach((input) => {
                const size = input.getAttribute("data-b2b-size");
                const counts = input.getAttribute("data-b2b-part") === "top" ? topCounts : botCounts;
                const q = split ? 0 : counts[size] || 0;
                if (document.activeElement !== input) input.value = q;
                input.setAttribute("data-b2b-in-order", q);
              });
            } else {
              const fills = [];
              b2bRoot.querySelectorAll(".b2b-qa__qty[data-variant-id]").forEach((input) => {
                const vid = String(input.getAttribute("data-variant-id"));
                if ((linesByVid[vid] || 0) > 1) split = true;
                const q = qtyByVid[vid] || 0;
                total += q;
                fills.push([input, q]);
              });
              fills.forEach((pair) => {
                const q = split ? 0 : pair[1];
                if (document.activeElement !== pair[0]) pair[0].value = q;
                pair[0].setAttribute("data-b2b-in-order", q);
              });
            }
            b2bInOrderTotal = split ? 0 : total;
            b2bSetLabel();
          })
          .catch(() => {});
      };

      // Prefill on every open, so the card is right even after navigating
      // away and back, or after the Order Sheet changed the quantities.
      openBtn.addEventListener("click", () => {
        if (openBtn.dataset.variantId) return;
        b2bSync();
      });

      b2bSubmit.addEventListener("click", async (e) => {
        e.preventDefault();
        const msgEl = b2bRoot.querySelector(".b2b-qa__msg");
        const showMsg = (t) => {
          if (msgEl) { msgEl.textContent = t; msgEl.hidden = false; }
        };
        // Compact size token for the confirmation, e.g. 2S or 3 ONE SIZE.
        const sizeToken = (label, q) => {
          const clean = String(label || "").trim().toUpperCase();
          return clean.length > 3 ? q + " " + clean : q + clean;
        };
        const updating = b2bStateful && b2bInOrderTotal > 0;
        const items = [];
        let updates = null;
        const summaryParts = [];
        let runTotal = 0;
        if (b2bTwoWrap) {
          // TOP/BOT bikini rows: totals must match, then tops and bottoms
          // are paired size by size, in row order, into the combination
          // variants carried by the JSON map.
          const collect = (part) => {
            const list = [];
            b2bTwoWrap.querySelectorAll('.b2b-qa__qty[data-b2b-part="' + part + '"]').forEach((input) => {
              const q = parseInt(input.value, 10);
              if (!isNaN(q) && q > 0) list.push({ size: input.getAttribute("data-b2b-size"), qty: q });
            });
            return list;
          };
          const tops = collect("top");
          const bots = collect("bot");
          const topTotal = tops.reduce((s, r) => s + r.qty, 0);
          const botTotal = bots.reduce((s, r) => s + r.qty, 0);
          if (topTotal === 0 && botTotal === 0 && !updating) {
            showMsg("Please enter a quantity.");
            return;
          }
          if (topTotal !== botTotal) {
            showMsg("Tops and bottoms ship as sets. You have " + topTotal + " TOP and " + botTotal + " BOT; please match the totals.");
            return;
          }
          const map = b2bReadTwoMap();
          const expand = (rows) => {
            const seq = [];
            rows.forEach((r) => { for (let i = 0; i < r.qty; i++) seq.push(r.size); });
            return seq;
          };
          const topSeq = expand(tops);
          const botSeq = expand(bots);
          const comboCounts = {};
          for (let i = 0; i < topSeq.length; i++) {
            const key = topSeq[i] + "||" + botSeq[i];
            comboCounts[key] = (comboCounts[key] || 0) + 1;
          }
          for (const key in comboCounts) {
            const bits = key.split("||");
            const match = map.find((v) => String(v[b2bTopOpt]) === bits[0] && String(v[b2bBotOpt]) === bits[1]);
            if (!match || match.off) {
              showMsg("TOP " + bits[0] + " with BOT " + bits[1] + " is not available. Please adjust the split.");
              return;
            }
            if (comboCounts[key] > match.max) {
              showMsg("Only " + match.max + " available as TOP " + bits[0] + " with BOT " + bits[1] + ".");
              return;
            }
          }
          if (updating) {
            // Absolute quantities for EVERY combination variant, zeros
            // included, so pairings that no longer exist are removed.
            updates = {};
            map.forEach((v) => {
              const key = String(v[b2bTopOpt]) + "||" + String(v[b2bBotOpt]);
              updates[String(v.id)] = comboCounts[key] || 0;
            });
            runTotal = topTotal;
          } else {
            for (const key in comboCounts) {
              const bits = key.split("||");
              const match = map.find((v) => String(v[b2bTopOpt]) === bits[0] && String(v[b2bBotOpt]) === bits[1]);
              items.push({ id: parseInt(match.id, 10), quantity: comboCounts[key] });
              runTotal += comboCounts[key];
            }
          }
          if (topTotal > 0) {
            summaryParts.push("TOP " + tops.map((r) => sizeToken(r.size, r.qty)).join(", "));
            summaryParts.push("BOT " + bots.map((r) => sizeToken(r.size, r.qty)).join(", "));
          }
        } else {
          const inputs = Array.from(b2bRoot.querySelectorAll(".b2b-qa__qty[data-variant-id]"));
          const runSummary = new Map();
          inputs.forEach((input) => {
            const q0 = parseInt(input.value, 10);
            const q = isNaN(q0) || q0 < 0 ? 0 : q0;
            if (updating) {
              // Every cell, zeros and disabled cells included: a zero
              // removes the size, and a disabled cell still holds the
              // buyer's units (it prefilled from the cart), so dropping it
              // would quietly delete them.
              if (!updates) updates = {};
              updates[String(input.getAttribute("data-variant-id"))] = q;
            } else if (q > 0 && !input.disabled) {
              items.push({ id: parseInt(input.getAttribute("data-variant-id"), 10), quantity: q });
            }
            if (q > 0) {
              runTotal += q;
              const runEl = input.closest(".b2b-qa__run");
              const cellEl = input.closest(".b2b-qa__cell");
              const sizeEl = cellEl ? cellEl.querySelector(".b2b-qa__size") : null;
              const token = sizeToken(sizeEl ? sizeEl.textContent : "", q);
              if (!runSummary.has(runEl)) runSummary.set(runEl, []);
              runSummary.get(runEl).push(token);
            }
          });
          if (!updating && items.length === 0) {
            showMsg("Please enter a quantity.");
            return;
          }
          runSummary.forEach((tokens, runEl) => {
            const head = runEl ? runEl.querySelector(".b2b-qa__run-header") : null;
            const label = head ? head.textContent.trim().toUpperCase() + " " : "";
            summaryParts.push(label + tokens.join(", "));
          });
        }
        let companions = [];
        try {
          const raw = b2bRoot.getAttribute("data-b2b-companions");
          if (raw) companions = JSON.parse(raw);
        } catch (err) { companions = []; }
        companions.forEach((c) => {
          if (!c || !c.id) return;
          const cq = c.per === "total" ? runTotal : parseInt(c.qty, 10);
          if (!isNaN(cq) && cq > 0) items.push({ id: parseInt(c.id, 10), quantity: cq });
        });
        if (msgEl) { msgEl.hidden = true; msgEl.textContent = ""; }
        b2bBusy = true;
        b2bSubmit.disabled = true;
        b2bSubmit.textContent = updating ? "UPDATING..." : "ADDING...";
        try {
          const response = await fetch(updating ? "/cart/update.js" : "/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify(updating ? { updates: updates } : { items: items }),
          });
          if (!response.ok) {
            const data = await response.json().catch(() => ({}));
            throw new Error((data && (data.description || data.message)) || "Something went wrong. Your order was not changed.");
          }
          await response.json();
          b2bBusy = false;
          b2bSubmit.disabled = false;
          const summary = summaryParts.join(" · ");
          if (b2bStateful) {
            // Values stay: they are the buyer's totals now. The re-read
            // below settles cells, mode and the button from the cart truth.
            if (updating) {
              showMsg(summary ? "ORDER UPDATED: " + summary : "REMOVED FROM ORDER.");
            } else {
              showMsg(summary ? "ADDED TO ORDER: " + summary : "ADDED TO ORDER");
            }
            await b2bSync();
          } else {
            b2bRoot.querySelectorAll(".b2b-qa__qty").forEach((input) => { input.value = 0; });
            showMsg(summary ? "ADDED TO ORDER: " + summary : "ADDED TO ORDER");
            b2bSetLabel();
          }
          document.dispatchEvent(new CartUpdateEvent({ source: "b2b-quick-add" }));
        } catch (err) {
          b2bBusy = false;
          b2bSubmit.disabled = false;
          b2bSetLabel();
          showMsg((err && err.message) ? err.message : "Something went wrong. Your order was not changed.");
        }
      });
    }

    // B2B QUICK-ADD availability + caps. Rows rendered from the size-run
    // metafield carry data-b2b-handle (the component product handle); on the
    // first popup open we fetch each handle's /products/<handle>.js once and
    // grey out variants that are sold out. Inputs that carry data-b2b-max
    // (server-rendered caps on own-variant products) are clamped on input.
    // Numeric caps for metafield-run components are enforced at the Order
    // Sheet, which is the authoritative gate.
    if (b2bRoot && !b2bRoot.dataset.b2bAvailBound) {
      b2bRoot.dataset.b2bAvailBound = "true";

      const b2bMsg = b2bRoot.querySelector(".b2b-qa__msg");
      let b2bNoteTimer = null;

      const showB2bNote = (text) => {
        if (!b2bMsg) return;
        b2bMsg.textContent = text;
        b2bMsg.hidden = false;
        if (b2bNoteTimer) clearTimeout(b2bNoteTimer);
        b2bNoteTimer = setTimeout(() => {
          b2bMsg.hidden = true;
        }, 4000);
      };

      const clampB2bInput = (input) => {
        const maxAttr = input.getAttribute("data-b2b-max");
        if (maxAttr === null) return;
        const max = parseInt(maxAttr, 10);
        if (isNaN(max)) return;
        const q = parseInt(input.value, 10);
        if (!isNaN(q) && q > max) {
          input.value = max;
          showB2bNote("Adjusted to available quantity.");
        }
      };

      b2bRoot.querySelectorAll(".b2b-qa__qty[data-variant-id]").forEach((input) => {
        input.addEventListener("input", () => clampB2bInput(input));
        input.addEventListener("change", () => clampB2bInput(input));
      });

      // Focus selects the whole value (Vic 2026-08-28): typing into a cell
      // REPLACES the 0 or the held quantity instead of appending to it, so
      // a buyer can never turn 4 into 40 by accident. The setTimeout defers
      // the select past the click's own mouseup, which would otherwise
      // clear the selection the moment it was made.
      b2bRoot.querySelectorAll(".b2b-qa__qty").forEach((input) => {
        input.addEventListener("focus", () => {
          setTimeout(() => {
            try { input.select(); } catch (err) {}
          }, 0);
        });
      });

      const applyB2bAvailability = () => {
        if (b2bRoot.dataset.b2bAvailApplied === "true") return;
        b2bRoot.dataset.b2bAvailApplied = "true";
        const groups = Array.from(b2bRoot.querySelectorAll("[data-b2b-handle]"));
        const handles = [];
        groups.forEach((group) => {
          const handle = group.getAttribute("data-b2b-handle");
          if (handle && handles.indexOf(handle) === -1) handles.push(handle);
        });
        handles.forEach((handle) => {
          if (!b2bComponentCache[handle]) {
            b2bComponentCache[handle] = fetch(`/products/${handle}.js`, {
              headers: { Accept: "application/json" },
            })
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null);
          }
          b2bComponentCache[handle].then((data) => {
            if (!data || !data.variants) return;
            const availability = {};
            data.variants.forEach((v) => {
              availability[String(v.id)] = !!v.available;
            });
            groups.forEach((group) => {
              if (group.getAttribute("data-b2b-handle") !== handle) return;
              group.querySelectorAll(".b2b-qa__qty[data-variant-id]").forEach((input) => {
                const vid = String(input.getAttribute("data-variant-id"));
                if (availability[vid] === false) {
                  input.disabled = true;
                  input.value = 0;
                  const cell = input.closest(".b2b-qa__cell");
                  if (cell) cell.classList.add("b2b-qa__cell--unavailable");
                }
              });
            });
          });
        });
      };

      openBtn.addEventListener("click", () => {
        if (openBtn.dataset.variantId) return;
        applyB2bAvailability();
      });
    }
  });
}

window.initProductCustom = initProductCustom;

// INIT
document.addEventListener("DOMContentLoaded", () => {
  window.initProductCustom();

  // INFINITE SCROLL SUPPORT
  const productObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return;

        if (
          node.matches(".atc-icon-wrapper") ||
          node.querySelector(".atc-icon-wrapper")
        ) {
          window.initProductCustom(node);
        }
      });
    });
  });

  productObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // CLOSE ALL POPUPS
  window.addEventListener("click", (e) => {
    if (
      e.target.closest("popup-component") ||
      e.target.closest(".popup__size") ||
      e.target.closest(".popup_ajax_size")
    ) {
      return;
    }
    document.querySelectorAll(".variant-popup").forEach((popup) => {
      popup.classList.remove("active");
        document.body.classList.remove("cstm-pro-overlay");
    });

    document.body.classList.remove("atc-opened");
  });
});


window.initPopupSlider = function(parent = document) {

  parent.querySelectorAll('.pop_image_container__innerr')
  .forEach((container) => {

    /*
    |--------------------------------------------------------------------------
    | PREVENT DOUBLE INIT
    |--------------------------------------------------------------------------
    */

    if (container.dataset.sliderInitialized === "true") {
      return;
    }

    container.dataset.sliderInitialized = "true";

    /*
    |--------------------------------------------------------------------------
    | YOUR CURRENT SLIDER CODE
    |--------------------------------------------------------------------------
    */

    const track = container.querySelector('.slider-track');

    let slides = container.querySelectorAll('.slide');

    const sizeWrapper =
      container.closest('.pop__contnet__inner')
      ?.querySelector('.sizes__wrapper');

    if (!track || !slides.length || !sizeWrapper) return;

    const sizeItems =
      sizeWrapper.querySelectorAll('.opener__handler');

    const originalCount = slides.length;

    /*
    |--------------------------------------------------------------------------
    | CLONES
    |--------------------------------------------------------------------------
    */

    const firstClone = slides[0].cloneNode(true);

    const lastClone =
      slides[originalCount - 1].cloneNode(true);

    track.appendChild(firstClone);

    track.insertBefore(lastClone, slides[0]);

    slides = container.querySelectorAll('.slide');

    let currentIndex = 1;

    let isAnimating = false;

    track.style.transition = 'none';

    track.style.transform =
      `translateX(-${currentIndex * 100}%)`;

    function getRealIndex(index) {

      if (index === 0) return originalCount - 1;

      if (index === originalCount + 1) return 0;

      return index - 1;

    }

    function updateActive(index) {

      const realIndex = getRealIndex(index);

      sizeItems.forEach(item =>
        item.classList.remove('activated')
      );

      if (sizeItems[realIndex]) {

        sizeItems[realIndex]
        .classList.add('activated');

      }

    }

    function moveTo(index) {

      if (isAnimating) return;

      isAnimating = true;

      currentIndex = index;

      track.style.transition =
        'transform 0.4s ease';

      track.style.transform =
        `translateX(-${currentIndex * 100}%)`;

      updateActive(currentIndex);

    }

    /*
    |--------------------------------------------------------------------------
    | BUTTONS
    |--------------------------------------------------------------------------
    */

    container.addEventListener('click', function (e) {

      if (e.target.closest('.next-btn')) {
        moveTo(currentIndex + 1);
      }

      if (e.target.closest('.pre-btn')) {
        moveTo(currentIndex - 1);
      }

    });

    /*
    |--------------------------------------------------------------------------
    | TRANSITION END
    |--------------------------------------------------------------------------
    */

    track.addEventListener('transitionend', (e) => {

      if (e.target !== track) return;

      if (currentIndex === originalCount + 1) {

        track.style.transition = 'none';

        currentIndex = 1;

        track.style.transform = `translateX(-100%)`;

      }

      if (currentIndex === 0) {

        track.style.transition = 'none';

        currentIndex = originalCount;

        track.style.transform =
          `translateX(-${originalCount * 100}%)`;

      }

      updateActive(currentIndex);

      isAnimating = false;

    });

    /*
    |--------------------------------------------------------------------------
    | TOUCH
    |--------------------------------------------------------------------------
    */

    let startX = 0;

    track.addEventListener('touchstart', (e) => {

      startX = e.touches[0].clientX;

    });

    track.addEventListener('touchend', (e) => {

      if (isAnimating) return;

      const endX = e.changedTouches[0].clientX;

      const diff = startX - endX;

      if (diff > 50) {

        moveTo(currentIndex + 1);

      } else if (diff < -50) {
        moveTo(currentIndex - 1);
      }

    });
    /*
    |--------------------------------------------------------------------------
    | SIZE BUTTONS
    |--------------------------------------------------------------------------
    */
    sizeItems.forEach((item, i) => {
      item.addEventListener('click', () => {
        isAnimating = false;
        moveTo(i + 1);
      });
    });
    updateActive(currentIndex);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  // if (document.body.classList.contains('template_handle_quick_add')) {
  //   initPopupSlider();
  // }
  const mobileLookProducts = document.querySelector('.mobile-look-products');
  const elementsToWatch = document.querySelectorAll( '.recently-viewed_container, .media-gallery__grid');
  if (mobileLookProducts && elementsToWatch.length) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            mobileLookProducts.classList.remove('active');
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    elementsToWatch.forEach((el) => observer.observe(el));
  }
});